// extracted by mini-css-extract-plugin
export default {"container":"KO_container__WwKbt","content":"KO_content__coDV-","title":"KO_title__J6sx9","description":"KO_description__XLs0Q","action":"KO_action__YP15R"};